<template>
  <div class="principal-hoja-prueba" data-app>
    <titulo-seccion titulo="VERIFICACIÓN DE DATOS"></titulo-seccion>
    <div class="container contenedor-hoja-prueba">
      <div class="row row-cols-lg-12 mt-3">
        <strong class="titulo-seccion">Verificación de datos</strong>
        <p class="parrafo-instrucciones mt-2">
          Debes verificar correctamente cada uno de los campos, ya que es
          necesario que cada uno de ellos, estén correctos, son campos editables
          así que puedes modificarlos para corregirlos o cambiarlos.
        </p>
      </div>
      <form
        class="requiere-validacion"
        novalidate
        ref="formularioConfirmacion"
        v-bind:class="{ 'was-validated': formularioValidado }"
      >
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba"
              >Nombre de la empresa</label
            >
            <input
              placeholder="Nombre de la empresa*"
              type="text"
              class="form-control campo-basico"
              v-model="datosBasicos.nombres"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              El nombre de la empresa es requerido.
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Razón social</label>
            <input
              placeholder="Razón social*"
              type="text"
              class="form-control campo-basico"
              v-model="datosBasicos.apellidoPaterno"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              La razón social de la empresa es requerida
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Monto</label>
            <VueAutonumeric
              class="form-control campo-basico"
              :options="{
                currencySymbol: '$',
                decimalPlaces: '2',
                minimumValue: '0',
                maximumValue: '15000000',
              }"
              :placeholder="'Monto'"
              disabled
              v-model="datosBasicos.monto"
            ></VueAutonumeric>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">RFC</label>
            <input
              maxlength="12"
              placeholder="RFC*"
              type="text"
              class="form-control campo-basico"
              v-model.lazy="datosSolicitudMoral.rfc"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              El RFC de la empresa es requerido.
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Servicio</label>
            <DropDown
              :disabled="this.soloLectura"
              placeholder="Selecciona ¿Qué servicio deseas?* "
              :arreglo="this.catalogos.servicios"
              llave="value"
              valor="value"
              texto="text"
              :requerido="true"
              v-model="datosSolicitud.servicio"
            ></DropDown>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba"
              >Lugar de constitución de la empresa</label
            >
            <input
              placeholder="Lugar de constitución de la empresa"
              :disabled="soloLectura"
              type="text"
              class="form-control campo-basico"
              required
              v-model="datosSolicitudMoral.lugarConstitucion"
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              El lugar de constitución es requerido.
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div
            class="col-lg-6 campo-solicitud"
            style="display: flex; flex-direction: column"
          >
            <label
              class="form-label label-hoja-prueba"
              style="text-align: initial"
              >Fecha en que fue constituida la empresa</label
            >
            <input-fecha
              idioma="es-MX"
              v-model="datosSolicitud.fechaNacimiento"
            ></input-fecha>
          </div>
          <div
            class="col-lg-6 campo-solicitud"
            style="display: flex; flex-direction: column"
          >
            <label
              class="form-label label-hoja-prueba"
              style="text-align: initial"
              >Fecha de inicio de operaciones de la empresa</label
            >
            <input-fecha
              idioma="es-MX"
              v-model="datosSolicitudMoral.fechaInicioOperaciones"
            ></input-fecha>
          </div>
        </div>
        <div class="row row-cols-lg-12 mt-4">
          <label
            class="form-label label-hoja-prueba"
            style="text-align: initial"
            >Domicilio de la empresa:</label
          >
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <input
              placeholder="Calle*"
              :disabled="soloLectura"
              type="text"
              class="form-control campo-basico"
              v-model="DatosUbicacionGeneralOficina.calle"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              La calle es requerida.
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <input
              placeholder="Número*"
              :disabled="soloLectura"
              type="text"
              min="0"
              class="form-control campo-basico"
              required
              v-model="DatosUbicacionGeneralOficina.numero"
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              El número es requerido.
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <input
              placeholder="Código postal*"
              :disabled="soloLectura"
              type="number"
              onkeydown="return event.keyCode !== 69"
              onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
              min="0"
              class="form-control campo-basico"
              required
              v-model="codigoPostalOficina"
              pattern="[0-9]{5}"
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              El código postal es requerido.
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <input
              placeholder="Estado *"
              type="text"
              class="form-control campo-basico"
              disabled
              v-model="direccionEmpresa.estado"
              pattern="[0-9]{5}"
            />
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <input
              placeholder="Ciudad *"
              type="text"
              class="form-control campo-basico"
              disabled
              v-model="direccionEmpresa.ciudad"
            />
          </div>
          <div
            class="col-lg-6 campo-solicitud"
            v-if="
              (codigoPostalValidoEmpresa == true &&
                catalogos.coloniasEmpresa.length > 0) ||
                coloniaExistenteOficina != null
            "
          >
            <DropDown
              :disabled="this.soloLectura"
              placeholder="Selecciona una colonia *"
              :arreglo="this.catalogos.coloniasEmpresa"
              llave="coloniaId"
              valor="coloniaId"
              texto="descripcion"
              v-model="DatosUbicacionOficina.coloniaId"
              :requerido="true"
            ></DropDown>
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              La colonia es requerida.
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Teléfono</label>
            <input
              style="height: 38px"
              :disabled="this.soloLectura"
              placeholder="Teléfono *"
              type="number"
              onkeydown="return event.keyCode !== 69"
              onkeypress="return event.keyCode !== 43 && event.keyCode !== 45 && event.keyCode !== 46"
              min="0"
              class="form-control campo-basico"
              v-model="PuntoContactoGeneral.telefonoFijoOficina.valor"
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              La teléfono de la empresa es requerido.
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba"
              >Correo electrónico</label
            >
            <input
              placeholder="Correo electrónico *"
              type="email"
              class="form-control campo-basico"
              v-model="PuntoContactoGeneral.correoMoral.valor"
              disabled
            />
          </div>
        </div>
        <button
          ref="envioFormulario"
          @click.prevent="ValidaFormulario"
          class="btn btn-primary"
          hidden
          type="submit"
        >
          submit
        </button>
      </form>
      <div class="row row-cols-lg-12 mt-5 row-confirmar">
        <button
          v-if="confirmandoDatos"
          type="button"
          disabled
          class="boton-primario boton-confirmar"
        >
          <v-progress-circular
            indeterminate
            size="30"
            color="primary"
          ></v-progress-circular>
        </button>
        <button
          v-else-if="!confirmandoDatos && esProspecto"
          type="button"
          :disabled="this.soloLectura"
          class="boton-primario boton-confirmar"
          @click.prevent="ConfirmarInformacion()"
        >
          Confirmar
        </button>
        <button
          v-else
          type="button"
          :disabled="true"
          class="boton-primario boton-confirmar"
        >
          Confirmar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
//Componentes
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import VueAutonumeric from "../../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric.vue";
import DropDown from "../components/DropDown.vue";
import InputFecha from "../components/InputFecha.vue";

//Mixins
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
import mixinHojaPrueba from "../Mixins/MixinHojaPrueba.js";
//Plugins
import axios from "axios";
//Servicios
import servicios from "../../../servicios/service.js";

//Rutas
const rutaActualizarDatosBasicos =
  "/api/Master/HojaPrueba/ActualizarDatosBasicosPersonaMoral";
const rutaEnviarACore = "/api/Master/PreAutorizacion/EnviarACore";

export default {
  name: "HojaPruebaMoral",
  components: {
    TituloSeccion,
    VueAutonumeric,
    DropDown,
    InputFecha,
  },
  mixins: [mixinSolicitudInscripcion, mixinHojaPrueba],
  mounted() {
    this.CargarServicios(false);
    this.ProspectoId = this.$store.getters.prospectoId;
    this.tipoPersona = this.$store.getters.tipoPersona;
    this.tipoUsuario = this.$store.getters.tipoUsuario;
    if (this.$store.getters.modoPago == 2) {
      this.modoPago = 2;
    } else {
      this.modoPago = 1;
    }
    if (this.tipoUsuario == 3 || this.tipoUsuario == 8) {
      this.esProspecto = true;
    }

    this.CargarDatosHojaPrueba(this.ProspectoId, this.tipoPersona);
  },
  watch: {
    "datosSolicitudMoral.rfc": function() {
      var expresionRegular = /[a-zA-Z]{3,3}[0-9]{2}[0-1][0-9][0-3][0-9][a-zA-Z,0-9][a-zA-Z,0-9][0-9aA]$/;
      if (
        (!expresionRegular.test(this.datosSolicitudMoral.rfc) ||
          this.datosSolicitudMoral.rfc.length > 13) &&
        this.datosSolicitudMoral.rfc.length != 0
      ) {
        this.rfcValido = false;
        this.AlertaEmbajadores(
          "El rfc " +
            this.datosSolicitudMoral.rfc.toUpperCase() +
            " con longitud  de (" +
            this.datosSolicitudMoral.rfc.length +
            ") " +
            "no cuenta con la longitud de 13 o el formato establecido 6 Letras, 3 números y 3 números o 2 números con la letra A",
          false
        );
      } else {
        this.rfcValido = true;
      }
    },
    "PuntoContactoGeneral.telefonoFijoOficina.valor": function() {
      this.PuntoContactoGeneral.telefonoFijoOficina.valor = servicios.LimitarTelefonoLocal(
        this.PuntoContactoGeneral.telefonoFijoOficina.valor
      );
    },
    codigoPostalOficina: function() {
      if (this.codigoPostalOficina.length > 5) {
        this.codigoPostalOficina = this.codigoPostalOficina
          .toString()
          .substring(0, 5);
      }
      if (this.codigoPostalOficina.length == 5) {
        this.ConsultarCodigoPostal(this.codigoPostalOficina, 1);
      }
    },
  },
  data() {
    return {
      ProspectoId: null,
      tipoPersona: null,
      tipoUsuario: null,
      solicitudExistenteId: null,
      catalogos: {
        servicios: [],
        coloniasEmpresa: [],
      },
      datosBasicos: {
        nombres: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        monto: null,
      },
      datosSolicitud: {
        solicitudId: null,
        fechaNacimiento: null,
        servicio: null,
      },
      datosSolicitudMoral: {
        rfc: null,
        lugarConstitucion: null,
        fechaInicioOperaciones: null,
      },
      rfcValido: false,
      //Puntos de contacto
      PuntoContactoGeneral: {
        correoMoral: {
          puntoContactoId: 0,
          valor: null,
        },
        correoRepresentante: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoMovil: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoFijo: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoFijoOficina: {
          puntoContactoId: 0,
          valor: null,
        },
      },
      //Ubicaciones
      DatosUbicacionGeneralOficina: {
        ubicacionId: 0,
        prospectoId: null,
        tipoUbicacion: 1,
        calle: null,
        numero: null,
      },
      DatosUbicacionOficina: {
        ubicacionId: null,
        coloniaId: null,
      },
      direccionEmpresa: {
        ciudad: null,
        estado: null,
      },
      coloniaExistenteOficina: null,
      codigoPostalOficina: null,
      codigoPostalValidoEmpresa: false,
      //Validacion del formulario
      formularioValidado: false,
      confirmandoDatos: false,
      soloLectura: false,
      modoPago: null,
      esProspecto: false,
    };
  },
  methods: {
    ConfirmarInformacion() {
      if (this.tipoUsuario != 3 && this.tipoUsuario != 8) {
        return;
      }
      this.$fire({
        title: this.tipoPersona != 2 ? "Confirmación" : "Confirmation",
        html:
          this.tipoPersona != 2
            ? "Confirmo que he leído y verificado que los datos mostrados son correctos. <br>Autorizo para que con estos datos, se genere el contrato."
            : "I confirm that I have read and verified that the data shown are correct.<br> I authorize the contract to be generated with this data.",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: this.tipoPersona != 2 ? "Confirmar" : "Confirm",
        cancelButtonText: this.tipoPersona != 2 ? "Volver" : "Back",
      }).then((result) => {
        if (result.value) {
          this.$refs.envioFormulario.click();
        }
      });
    },
    ValidaFormulario() {
      let esValido = false;
      this.formularioValidado = true;
      esValido = this.$refs.formularioConfirmacion.checkValidity();

      if (esValido) {
        this.confirmandoDatos = true;
        if (this.datosSolicitud.fechaNacimiento == null) {
          this.AlertaEmbajadores(
            this.tipoPersona != 2
              ? "Por favor indica la fecha de constitución de la empresa."
              : "Please indicate the date of incorporation of the company.",
            true
          );
          return;
        }
        if (this.datosSolicitudMoral.fechaInicioOperaciones == null) {
          this.AlertaEmbajadores(
            this.tipoPersona != 2
              ? "Por favor indica la fecha de incio de operaciones de la empresa."
              : "Please indicate the date the company started operations.",
            true
          );
          return;
        }
        if (this.rfcValido == false) {
          this.AlertaEmbajadores(
            this.tipoPersona != 2
              ? "Por favor indicar el RFC de la empresa con el formato correcto."
              : "Please indicate the RFC of the company with the correct format.",
            true
          );
          return;
        }
        this.ActualizarDatosBasicos();
        this.GuardarUbicacionGeneralOficina(false);
        this.GuardarPuntosDeContacto(false, false);

        this.$fire({
          title:
            //this.$store.getters.modoPago == 2
            this.modoPago == 2
              ? this.tipoPersona != 2
                ? "Se confirmaron correctamente tus datos, serás redirigido a tu Kit de Bienvenida"
                : "Your data has been successfully confirmed, you will be redirected to your Welcome Kit."
              : this.tipoPersona != 2
              ? "Se confirmaron correctamente tus datos, validaremos tu comprobante de pago."
              : "Your information has been successfully confirmed, we will validate your proof of payment.",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: this.tipoPersona != 2 ? "Aceptar" : "Accept",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.value) {
            if (this.modoPago == 2) {
              this.EnviarACore();
            } else {
              this.EnviarACore();
              this.AlertaEmbajadores(
                this.tipoPersona != 2
                  ? "Se confirmaron correctamente tus datos"
                  : "Your data has been successfully confirmed",
                true
              );
            }
          }
        });
      } else {
        this.confirmandoDatos = false;
      }
    },
    EnviarACore() {
      axios
        .post(
          rutaEnviarACore +
            "/?prospectoId=" +
            this.ProspectoId +
            "&solicitudId=" +
            this.datosSolicitud.solicitudId +
            "&aplicacionId=0" +
            "&modoPago=" +
            this.modoPago
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.$store.commit("setModoPago", null);
            this.AlertaEmbajadores(resp.data.mensaje, true)
            this.$router.push({
              name: "SeguimientoProspecto",
            });
          } else if (resp.data.estado === 1) {
            this.confirmandoDatos = false;
            this.$fire({
              title: "Aviso",
              text: resp.data.mensaje,
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "Aceptar",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.value) {
                this.$router.push({ path: "SeguimientoProspecto" });
              }
            });
            if (this.modoPago == 2) {
              this.confirmandoDatos = false;
              this.$router.push({ path: "SeguimientoProspecto" });
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    ActualizarDatosBasicos() {
      let ruta =
        rutaActualizarDatosBasicos +
        "?prospectoId=" +
        this.ProspectoId +
        "&nombres=" +
        this.datosBasicos.nombres +
        "&apellidoPaterno=" +
        this.datosBasicos.apellidoPaterno +
        "&rfc=" +
        this.datosSolicitudMoral.rfc +
        "&servicio=" +
        this.datosSolicitud.servicio +
        "&fechaNacimiento=" +
        this.datosSolicitud.fechaNacimiento +
        "&fechaInicioOperaciones=" +
        this.datosSolicitudMoral.fechaInicioOperaciones +
        "&lugarConstitucion=" +
        this.datosSolicitudMoral.lugarConstitucion;
      axios
        .post(ruta)
        .then(() => {})
        .catch((e) => this.ManejarExcepcion(e));
    },
  },
};
</script>

<style lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
</style>
